import { Popover, PopoverContent, PopoverTrigger } from 'ui/popover';
import React, { useState } from 'react';
import styled from 'styled-components';
import { pxToRem } from 'utils/convert';
import { usePopoverDetails } from './usePopoverDetails';

const StyledList = styled.ul`
  padding-left: ${pxToRem(16)};
  margin-bottom: 0px;

  margin-left: 0px;
  list-style-type: disc;
`;

const StyledPopoverContent = styled(PopoverContent)`
  filter: drop-shadow(0px 16px 24px rgb(0 0 0 / 0.06));
  &:focus-visible {
    outline: none;
  }
`;

const StyledTrigger = styled(PopoverTrigger)`
  &:focus-visible {
    outline: none;
  }
`;

export const CampaignPopover = ({
  children,
}: {
  children: React.ReactElement | React.ReactElement[];
}) => {
  const [showPopover, setShowPopover] = useState(false);
  const items = usePopoverDetails();

  const hasErrors = items.length > 0;
  return (
    <Popover open={showPopover && hasErrors}>
      <StyledPopoverContent
        TitleContent={`${items.length} ${
          items.length > 1 ? 'issues need' : 'issue needs'
        } your attention`}
        side="right"
      >
        <StyledList>
          {items.map((x, i) => (
            <li key={`errors-${i}`}>{x}</li>
          ))}
        </StyledList>
      </StyledPopoverContent>
      <StyledTrigger asChild>
        <div onMouseEnter={() => setShowPopover(true)} onMouseLeave={() => setShowPopover(false)}>
          {Array.isArray(children)
            ? React.Children.map(children, (child) =>
                React.cloneElement(child, {
                  isDisabled: hasErrors || child.props.isDisabled,
                }),
              )
            : React.cloneElement(children, { isDisabled: hasErrors || children.props.isDisabled })}
        </div>
      </StyledTrigger>
    </Popover>
  );
};
